<template>
  <div class="row">
    <form v-on:submit="sendLogin"></form>
    <div class="col-md-8">
      <card class="text-center">
        <div class="card-header">
          <h5 slot="header" class="title">Login</h5>
        </div>
        <div class="card-body">
          <base-input label="Username"
                      placeholder="Username"
                      v-model="username">
          </base-input>
          <base-input label="Password"
                      type="password"
                      placeholder="password"
                      v-model="password">
          </base-input>

        </div>
        <div class="card-footer text-muted">
          <base-button v-on:click="sendLogin" slot="footer" type="primary" fill>Submit</base-button>
        </div>
      </card>
    </div>
  </div>
</template>
<script>

  export default {
    components: {
    },
    methods: {
      sendLogin(e) {
        if (this.username === '' || this.password === '') {
          this.$notify({
            // icon: "tim-icons icon-bell-55",
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'warning',
            message: 'fill username and password field.',
            timeout: 3000
          });
        } else {
          let FormData = require('form-data');
          let data = new FormData();
          data.append('username', this.username);
          data.append('password', this.password);
          let config = {
            method: 'post',
            url: 'token/',
            headers: { "Content-Type": "multipart/form-data" },
            data : data
          };
          this.axios(config)
            .then((response) => {
              localStorage.setItem("access_token", response.data['access']);
              localStorage.setItem("refresh_token", response.data['refresh']);
              const token = localStorage.getItem('access_token');
              this.$notify({
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'success',
                message: 'Welcome ' + this.username + '.',
                timeout: 3000
              });
              if (token) {
                this.axios.defaults.headers.common['Authorization'] = token
              }
              this.$router.push({
                path: "/"
              });
              console.log(response)
            }).catch(error => {
            console.log(error.response);
            // type: ["", "info", "success", "warning", "danger"],
            let message;
            if (error.status)
              if (error.response.status === 400) {
                if (error.response.data['error'] === 'invalid_grant')
                  message = 'Invalid username/password.';
                else
                  message = 'Problem with login.<br>message: ' + error.response.data['error'];
              } else {
                message = 'There are some problem.\nContact system admins.';
              }
            else
              message = error;
            this.$notify({
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'danger',
              message: message,
              timeout: 3000
            });
          });
        }
      }
    },
    data() {
      return {
        username: '',
        password: ''
      }
    }
  }
</script>
<style>
</style>
